import React from 'react';

const ErrorLabel = (props) => {
  const { error, className } = props || {};

  return (
    <div className="position-relative">
      {error && (
        <label
          className={`${className} wrapper-fade-in-short error-input-label`}
          title={error}
        >
          {error}
        </label>
      )}
    </div>
  );
};

export default ErrorLabel;
